export function selectedOptionIndexes(answerValue: unknown): number[] {
    const values = Array.isArray(answerValue) ? answerValue : [answerValue];
    return values.map(Number).filter(Number.isInteger);
}

export function selectedOptionLabels(
    questionOptions: string[] | null | undefined,
    answerValue: unknown,
): string {
    const labels = selectedOptionIndexes(answerValue)
        .map((index) => questionOptions?.[index])
        .filter((label): label is string => Boolean(label));

    return labels.length > 0 ? labels.join(", ") : String(answerValue);
}
